import type {ReactElement} from 'react';
import type {GridShapeThumbProps} from './grid-shape-thumb.types';
import styles from './grid-shape-thumb.module.scss';

/**
 * Stock-shape thumbnail recolored to the design-system tertiary content color via a CSS filter on a plain <img>.
 * Deliberately NOT a CSS mask: browsers fetch mask-image in CORS mode, which fails against the plainly-cached
 * CDN copy of the same URL, leaving the tile invisible. A filtered <img> is a plain no-CORS load end to end.
 * The data attribute lets the canvas-item-drag library pick this element as the ghost.
 */
export function GridShapeThumb({thumbSrc, className = ''}: GridShapeThumbProps): ReactElement {
  return <img data-canvas-drag-thumb="" className={`${styles.thumb} ${className}`} src={thumbSrc} alt={window.i18next.t('pmwjs_image')} />;
}
